import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {


  static getCurrentLanguage(): string {
    if (localStorage.getItem('language')) {
      return localStorage.getItem('language').toUpperCase();
    } else {
      return 'nl'.toUpperCase();
    }
  }

  static setCurrentLanguage(language: string) {
    localStorage.setItem('language', language.toUpperCase());
  }
}
